"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Switch = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./Switch.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Switch](https://vanillaframework.io/docs/patterns/switch) component.
 */
const Switch = _ref => {
  let {
    label,
    disabled = false,
    help,
    helpClassName,
    ...inputProps
  } = _ref;
  const helpId = (0, _react.useId)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("label", {
    className: "p-switch"
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    type: "checkbox",
    className: "p-switch__input",
    role: "switch",
    disabled: disabled
  }, inputProps)), /*#__PURE__*/_react.default.createElement("span", {
    className: "p-switch__slider"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "p-switch__label"
  }, label)), help && /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _classnames.default)("p-form-help-text", "switch-help-text", helpClassName),
    id: helpId
  }, help));
};
exports.Switch = Switch;
var _default = exports.default = Switch;